module.exports = __webpack_public_path__ + "img/news34-0.c152f759.png";